/**
 * `id` in localStorage is set with JSON.stringify (Login / Registration).
 * Parse so API payloads contain a bare string/number form, not a quoted JSON fragment.
 */
export function getStoredUserId() {
    const raw =
        typeof window !== 'undefined' ? window.localStorage.getItem('id') : null
    if (raw == null || raw === '') return ''
    try {
        const parsed = JSON.parse(raw)
        return parsed == null ? '' : String(parsed)
    } catch {
        return raw
    }
}

/**
 * JWT is stored as a plain string in most login flows, but Google-auth registration
 * mistakenly wraps it with JSON.stringify, leaving surrounding quotes in localStorage.
 * This utility strips those extra quotes so the token is always a bare JWT string.
 */
export function getStoredJwt() {
    const raw =
        typeof window !== 'undefined' ? window.localStorage.getItem('jwt') : null
    if (raw == null || raw.trim() === '') return null
    // If the value starts with a quote it was stored via JSON.stringify — unwrap it.
    try {
        const parsed = JSON.parse(raw)
        if (typeof parsed === 'string' && parsed.trim() !== '') return parsed
    } catch {
        /* raw is already a plain string — fall through */
    }
    return raw
}
